import { useContext } from "react";
import {
  useCreateCustomObjectGroupMutation,
  useGetCustomObjectGroupsQuery,
} from "../../../../generated/graphql";
import { AuthContext } from "../../../Authorization/AuthContext";
import { Box, FlexRow } from "../../../Common/__styles__/Layout";
import { Button } from "../../../Common/Buttons/Button";
import {
  Header,
  HeaderTitle,
  HelperText,
  Section,
  SectionTitle,
} from "../../__styles__/Content";
import CustomObjectGroupsTable from "./CustomObjectGroupsTable";
import { useUpsertCustomObjectGroupModal } from "./upsertCustomObjectGroupModal";

const ObjectGroups = () => {
  const { account } = useContext(AuthContext);

  const { data, error, loading, previousData, refetch } =
    useGetCustomObjectGroupsQuery({
      variables: { accountId: account!.id },
    });

  const [createCustomObjectGroupMutation] =
    useCreateCustomObjectGroupMutation();

  const [showUpsertCustomObjectGroupModal] = useUpsertCustomObjectGroupModal({
    onSubmit: createCustomObjectGroupMutation,
    refetch,
  });

  if (error) {
    return <div />;
  }

  return (
    <Box>
      <Header accountSettings>
        <HeaderTitle accountSettings>Object settings</HeaderTitle>
      </Header>

      <Section>
        <FlexRow style={{ justifyContent: "space-between" }}>
          <SectionTitle>Groups</SectionTitle>

          <Button
            variant="outline"
            size="small"
            iconStart="plus"
            onPress={() => {
              showUpsertCustomObjectGroupModal(null);
            }}
            title="Add group"
          />
        </FlexRow>

        <HelperText>
          Add groups of related objects to organize map layers and configure
          object tables.
        </HelperText>
        <CustomObjectGroupsTable
          currentData={data?.account?.customObjectGroups ?? []}
          previousData={previousData?.account?.customObjectGroups ?? []}
          loading={loading}
          refetch={refetch}
        />
      </Section>
    </Box>
  );
};

export default ObjectGroups;
